
/**
 * @Description //TODO 文件功能说明：路由组件
 * @author CC
 * @date 2021/6/2
 * @Ver 1.0.0
 * @extends Vue
 */

import Vue from 'vue'
import Router from 'vue-router'

import ManagerApp from '@/views/ManagerApp'

/* 一级路由 */
import Login from '@/views/Login'

/* 主界面 */
import Layout from '@/components_index/Layout'
/* 主界面 */
import AutoMap from '@/views/system-manager/map/AutoMap'

/* 二级路由 */
import BsDevice from '@/views/system-manager/device/BsDevice'
import BindingRecord from '@/views/system-manager/record/BindingRecord'
import HeatMap from '@/views/system-manager/map/HeatMap'

/* 信息采集 */
import User from '@/views/system-manager/user/User'
import Car from '@/views/system-manager/car/Car'

// 历史记录
import UserRecord from '@/views/system-manager/record/UserRecord'		// 历史记录 人员
import CarRecord from '@/views/system-manager/record/CarRecord'			// 历史记录 车辆
import GpsTagRecord from '@/views/system-manager/record/GpsTagRecord'	// 历史记录 Gps Tag

/* 电子围栏 */
import FenceSet from '@/views/system-manager/fence/FenceSet'

/* 定位监控 */
import LocationReal from '@/views/system-manager/location/LocationReal'
import LocationTrack from '@/views/system-manager/location/LocationTrack'

/* 系统管理 */
import Account from '@/views/system-manager/system/Account'
import ParamC from '@/views/system-manager/system/ParamC'

/* 主界面 */
import Index from '@/views/system-tunnel/Index'

import mapConfig from '@/views/system-manager/map/Organization'

/* 进场情况 */
import ApproachT from '@/views/system-manager/approach/ApproachT'
import ApproachR from '@/views/system-manager/approach/ApproachR'

/* 隧道监测 */
import GasDetection from '@/views/system-manager/gas/GasInfo'

/* 报警管理 */
import AlarmReal from '@/views/system-manager/alarm/AlarmReal';						// 实时报警
import AlarmRecord from '@/views/system-manager/alarm/AlarmRecord';					// 报警记录
import Log from '@/views/system-manager/log'
import TagDevice from "@/views/system-manager/device/TagDevice";
import VideoDevice from "@/views/system-manager/video/VideoSet";
import GNSSDevice from "@/views/system-manager/device/GNSSDevice";

/* 室外地图 */
import Home from '@/views/system-outdoor/home/Home'									// 首页
import OutdoorMonitor from '@/views/system-outdoor/outdoor/OutdoorMonitor'			// 实时位置
import OutdoorTrack from '@/views/system-outdoor/outdoor/OutdoorTrack'				// 历史轨迹
import GpsTagConfig from '@/views/system-outdoor/device/gpsTagConfig'				// 设备配置 GNSS
import Organization from '@/views/system-outdoor/organization/Organization'			// 项目管理

// 使用路由
Vue.use(Router)

// 向外暴露路由
export default new Router({
	//mode: 'history', // 去掉url中的#
	routes: [
		/* 登录 */
		{
			// 路由路径
			path: '/login',
			// 路由名称
			name: 'login',
			// 组件名
			component: Login
		},
		/* 默认访问路径 */
		{
			path: '/',
			name: '默认登录',
			redirect: '/login'
		},
		
		/* 快捷地图 */
		{
			// 路由路径
			path: '/automap',
			// 路由名称
			name: 'automap',
			// 组件名
			component: AutoMap
		},
		
		/* 室外地图 */
		{
			// 路由路径
			path: '/outdoorMonitor',
			// 路由名称
			name: 'outdoorMonitor',
			// 组件名
			component: OutdoorMonitor
		},
		
		/* 总应用路由 */
		{
			// 路由路径
			path: '/manager',
			// 组件名
			component: Layout,
			meta: {
				requireAuth: true
			},
			// 二级路由
			children:[
				{
					path: 'home',
					name: 'home',
					component: Home,// OutdoorMonitor,// Index,// LocationReal
					meta: {
						requireAuth: true
					},
				},
				{
					path: 'index',
					name: 'index',
					redirect: 'home'
				},
				{
					path: 'position-real',
					name: 'position-real',
					component: OutdoorMonitor,// Index,// LocationReal
					meta: {
						requireAuth: true
					},
				},
				{
					path: 'project',
					name: 'project',
					component: Organization,
					meta: {
						requireAuth: true
					},
				},
                {
					path: '',
					name: 'manage-default',
					redirect: 'home'
				},
                {
		            path: 'location',
		            name: '定位',
		            // 组件名
		            component: ManagerApp,
		            children: [
		                {
		                    path: 'monitor',
		                    name: '定位监控',
		                    component: LocationReal,
		                    meta: {
		                        requireAuth: true
		                    }
		                },
		                {
		                    path: 'history',
		                    name: '历史轨迹',
		                    component: OutdoorTrack,// LocationTrack,
		                    meta: {
		                        requireAuth: true
		                    }
		                },
		                {
		                    path: 'fence',
		                    name: '电子围栏',
		                    component: FenceSet,
		                    meta: {
		                        requireAuth: true
		                    }
		                },
		            ]
		        },
		        {
                    path: 'alarm',
                    name: '报警',
                    // 组件名
                    component: ManagerApp,
                    children: [
                        {
                            path: 'real',
                            name: '实时报警',
                            component: AlarmReal,
                            meta: {
                                requireAuth: true
                            }
                        },
                        {
                            path: 'history',
                            name: '历史报警',
                            component: AlarmRecord,
                            meta: {
                                requireAuth: true
                            }
                        },
                    ]
                },
		        {
                    path: 'info',
                    name: '信息采集',
                    // 组件名
					component: ManagerApp,
                    children: [
                        {
                            path: 'user',
                            name: '人员信息',
                            component: User,
                            meta: {
                                requireAuth: true
                            }
                        },
                        {
                            path: 'car',
                            name: '车辆信息',
                            component: Car,
                            meta: {
                                requireAuth: true
                            }
                        },
                        {
                            path: 'bindingRecords',
                            name: '绑定记录',
                            component: BindingRecord,
                            meta: {
                                requireAuth: true
                            }
                        },
                        {
                            path: 'heatMap',
                            name: '热力图',
                            component: HeatMap,
                            meta: {
                                requireAuth: true
                            }
                        },
                    ]
                },
                {
                    path: 'device',
                    // name: 'device',
                    // 组件名
					component: ManagerApp,
                    children: [
                    	{
							path: '',
							name: 'device-default',
							redirect: 'gps'
						},
                        {
                            path: 'bs',
                            name: 'UWB基站',
                            component: BsDevice,
                            meta: {
                                requireAuth: true
                            }
                        },
                        {
                            path: 'tag',
                            name: 'UWB标签',
                            component: TagDevice,
                            meta: {
                                requireAuth: true
                            }
                        },
                        {
                            path: 'gnss',
                            name: 'GNSS标签',
                            component: GNSSDevice,
                            meta: {
                                requireAuth: true
                            }
                        },
                        {
                            path: 'video',
                            name: '监控视频',
                            component: VideoDevice,
                            meta: {
                                requireAuth: true
                            }
                        },
                        {
                            path: 'gps',
                            name: 'gps',
                            component: GpsTagConfig,
                            meta: {
                                requireAuth: true
                            }
                        },
                    ]
                },
                {
                    path: 'history',
                    name: 'history',
                    // 组件名
					component: ManagerApp,
                    children: [
                        {
                            path: 'device-record',
                            name: 'device-record',
                            component: GpsTagRecord,
                            meta: {
                                requireAuth: true
                            }
                        },
                        {
                            path: 'person-record',
                            name: 'person-record',
                            component: UserRecord,
                            meta: {
                                requireAuth: true
                            }
                        },
                        {
                            path: 'vehicle-record',
                            name: 'vehicle-record',
                            component: CarRecord,
                            meta: {
                                requireAuth: true
                            }
                        },
                        {
                            path: 'heatMap',
                            name: 'heatMap',
                            component: HeatMap,
                            meta: {
                                requireAuth: true
                            }
                        },
                    ]
                },
                {
                    path: 'tunnel',
                    name: 'tunnel',
                    // 组件名
					component: ManagerApp,
                    children: [
                        {
                            path: 'map',
                            name: '地图配置',
                            component: mapConfig,
                            meta: {
                                requireAuth: true
                            }
                        },
                        {
                            path: 'today',
                            name: '今日进场情况',
                            component: ApproachT,
                            meta: {
                                requireAuth: true
                            }
                        },
                        {
                            path: 'history',
                            name: '历史进场记录',
                            component: ApproachR,
                            meta: {
                                requireAuth: true
                            }
                        },
                        {
                            path: 'gas',
                            name: '隧道监测',
                            component: GasDetection,
                            meta: {
                                requireAuth: true
                            }
                        },
                    ]
                },
                {
					path: 'system',
					name: 'system',
					// 组件名
					component: ManagerApp,
					// 三级路由
					children: [
						{
							path: 'account',
							name: 'account',
							component: Account,
							meta: {
								requireAuth: true
							},
						},
						{
							path: 'paramConfig',
							name: 'paramConfig',
							component: ParamC,
							meta: {
								requireAuth: true
							},
						},
						{
							path: 'log',
							name: 'log',
							component: Log,
							meta: {
								requireAuth: true
							},
						},
						{
							path: 'org',
							name: 'org',
							component: Organization,
							meta: {
								requireAuth: true
							},
						},
					]
				},
				
			]
		},
		
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js